import type { TranslationMessages } from '../types';

export const menus: TranslationMessages = {
  title: 'Menus',
  subtitle: 'Manage your product menus',
  loading: 'Loading menus...',
  new_menu: 'New Menu',
  search_placeholder: 'Search menus...',
  no_menus: 'No menus yet. Create your first menu!',
  no_results: 'No menus found',
  load_error: 'Failed to load menus',
  delete_confirm: 'Are you sure you want to delete this menu?',
  delete_error: 'Failed to delete menu',
  menu_details: 'Menu Details',
  name_placeholder: 'Enter menu name',
  description_placeholder: 'Enter menu description (optional)',
  edit_subtitle: 'Edit menu configuration',
  create_subtitle: 'Create a new menu',
  save_error: 'Failed to save menu',
  select_categories: 'Select Categories',
  exclude_products: 'Uncheck products to exclude them from this menu:',
  products: 'products',
  no_categories: 'No categories available. Please create categories first.',
  active: 'Active',
  categories_count: 'Categories',
  menus: 'menus',
  exclude_categories: 'Exclude Categories',
  exclude_categories_description:
    'Exclude products from specific categories from this menu (e.g., exclude "Services" category from Services menu)',
  exclude_category_label: 'Exclude "%{name}" category',
  excluding_categories: 'Excluding categories: %{names}',
  parent_category: 'Parent Category',
  };
